import sortBy from 'lodash/sortBy';

const initialState = {
  offers: [],
  offerGroups: [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_OFFERS': {
      const { offers, offerGroups } = payload;
      const buy = [];
      const sell = [];
      offers.forEach(offer=>{
        if(offer.offer_type === 'buy'){
          buy.push(offer);
        }else if(offer.offer_type === 'sell'){
          sell.push(offer);
        }
      });
      const sorter = offer => offer.payment_method_name.toLowerCase();
      return {
        ...state,
        offers: sortBy(buy, sorter).concat(sortBy(sell, sorter)),
        offerGroups,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/Offers.reducer.js